import { post, postForm, get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import { get as merchantApiGet, post as merchantApiPost } from "helpers/api_helper/MerchantApiHelpers/merchantApiHelpers"
import * as url from "helpers/url_helper/url_helper"
 
export const getPaymentPageTransactionDataByUniqueId = paymentPageTransactionFilter => merchantApiPost(url.GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID, paymentPageTransactionFilter) 
export const hostedPageDoPayment = record => post(url.HOSTED_PAGE_DO_PAYMENT, record)
export const checkBinCardNumber = record => post(url.CHECK_BIN_CARD_NUMBER, record)